import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import Image from '@/src/shared/components/Image';
import { Button } from '@/src/shared/components/Button';
import styles from './index.module.scss';

const BookDemoPopup = dynamic(
  () => import('@/src/containers/ContactUs/components/BookDemoPopup'),
  {
    ssr: false,
  }
);

export function NeedHelp() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return (
    <>
      <section className={styles.container}>
        <div className={styles.body}>
          <div className={styles.content}>
            <h2 className={styles.title}>
              Have problem with your Roomvu account or need help?{' '}
            </h2>
            <p className={styles.description}>
              If you have any problems with your account or have any questions
              about how each part works, you can contact our support team.Also
              get up to date information about your Roomvu features in one place
            </p>
            <Button
              className={styles.bookADemo}
              color="link"
              onClick={() => setIsPopupOpen(true)}
              endIcon="arrow-right"
            >
              <span className={styles.label}>Book a Support Demo </span>
            </Button>
          </div>
          <div className={styles.microphoneImage}>
            <Image fill alt="" src="/images/contact-us/new/need-help.png" />
          </div>
        </div>
      </section>
      {isPopupOpen && (
        <BookDemoPopup
          onClose={() => setIsPopupOpen(false)}
          source="contact-us"
        />
      )}
    </>
  );
}
